import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { type BadgeVariant } from './badge.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.less',
})
export class BadgeComponent {
  public variant = input<BadgeVariant>('default');
  public label = input.required<string>();
  public textCase = input<'uppercase' | 'lowercase' | 'capitalize' | 'none'>('uppercase');
}
